const routes = [
    {
        path: '/rituals',
        component: () => import('@/pages/ritualCircles/RitualCircleHome.vue'),
        meta: { breadCrumb: 'Ritual Circles', entity: 'ritual' },
        children: [
            {
                path: '',
                name: 'ritualCircle',
                component: () => import('@/pages/ritualCircles/RitualCircleList.vue'),
                meta: { breadCrumb: 'All' },
            },
            {
                path: 'filter/:teamId?',
                name: 'filterRitual',
                component: () => import('@/pages/ritualCircles/RitualCircleList.vue'),
                meta: { breadCrumb: 'Filter' },
            },
            {
                path: 'new',
                name: 'newRitualCircle',
                component: () => import('@/pages/ritualCircles/Editor.vue'),
                meta: { breadCrumb: 'New' },
            },
            {
                path: ':id/edit',
                name: 'editRitualCircle',
                component: () => import('@/pages/ritualCircles/Editor.vue'),
                props: true,
                meta: { breadCrumb: 'Edit' },
            },
            {
                path: ':id/read/:tabName?',
                name: 'readRitualCircle',
                component: () => import('@/pages/ritualCircles/RitualCircleReader.vue'),
                props: true,
                meta: { breadCrumb: 'Read' },
            },
            {
                path: 'Archive',
                name: 'ritualCircleArchive',
                component: () => import('@/pages/ritualCircles/RitualCircleArchive.vue'),
                meta: { breadCrumb: 'Archive' },
            },
        ],
    },
]

export default routes
